import s from './brands.module.css';
import React from "react";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import useDocumentTitle from "../../assets/Tools/DocumentTitle/DocumentTitle";

const Brands = () => {

    useDocumentTitle('Производители');

    return (
        <div className={s.brands}>
            <div className={`${s.brandsContent} content`}>
                <Breadcrumbs/>
                <div className={s.brandsmain}>
                    <h3>Производители</h3>
                    <h5>Алфивитный указатель</h5>
                    <div className={s.brandLetter}>
                        <h5>Т</h5>
                        <div className={s.brandLinks}>
                            <a href="">ТМ "FaDolli Ricci"</a>
                            <a href="">ТМ "Дрема", г. Харьков</a>
                            <a href="">ТМ "Кухонные мелочи", г. Миргород, Украина</a>
                        </div>
                    </div>
                    <div className={s.brandLetter}>
                        <h5>Ф</h5>
                        <div className={s.brandLinks}>
                            <a href="">Фабрика "Viluta", г. Днепр</a>
                            <a href="">Фабрика "Vladi", г. Харьков</a>
                            <a href="">Фабрика "Ярослав", г. Киев</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Brands;